import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Install BootstrapVue — tooltips are globally disabled to prevent the
// tooltip overlay from intercepting pointer events on action buttons.
Vue.use(BootstrapVue, {
  BTooltip: { disabled: true }
});
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
